import React from 'react';
import { Headphones } from 'lucide-react';
import { voiceStatusLabel, voiceActivity } from '../../lib/voice-presentation';

const bars = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'];

export const VoiceIdentity = ({ voice, copy, prefix = 'voice' }) => {
  const status = voiceStatusLabel(voice, copy);
  const activity = voiceActivity(voice);
  return <div className={`voice-identity ${activity}`} data-testid={`${prefix}-call-identity`}>
    <div className="voice-agent-emblem" aria-hidden="true"><Headphones size={32} strokeWidth={1.3} /></div>
    <h3 data-testid={`${prefix}-call-name`}>Lawyah</h3>
    <p className="voice-agent-role" data-testid={`${prefix}-call-role`}>{copy.agent}</p>
    <div className="voice-waveform" aria-hidden="true">{bars.map((bar, index) => <i key={bar} style={{ '--bar': index }} />)}</div>
    <p className="voice-call-status" role="status" data-testid={`${prefix}-status`}>{status}</p>
    {voice.active && voice.remaining > 0 && <time className="voice-call-timer" data-testid={`${prefix}-time-remaining`}>{Math.floor(voice.remaining / 60)}:{String(voice.remaining % 60).padStart(2, '0')} {copy.remaining}</time>}
  </div>;
};